<template>
  <v-layout row wrap>
    <v-container>
      <h1 fluid class="text-xs-center" v-html="communityName"></h1>

      <v-layout row wrap>
        <v-flex xs12 class="mt-3">
          <tiptap-editor :content="about" :editable="false"></tiptap-editor>
        </v-flex>

        <v-container fluid grid-list-lg>
          <h2 fluid class="text-xs-center">Category Spaces</h2>
        </v-container>
        <v-flex v-for="(category, categoryIndex) in categories" :key="categoryIndex" xs6 sm2>
          <v-hover>
            <v-card slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" class="mx-auto">
              <v-card-text class="title font-weight-bold white--text text-xs-center" :class="category.color + ' lighten-3'"
                           style="min-height: 90px;display: flex;align-items: center;justify-content: center;">
                {{ category.name }}
              </v-card-text>
              <v-expand-transition>
                <div v-if="hover" class="d-flex transition-fast-in-fast-out teal darken-2 v-card--reveal subheading white--text"
                     style="height: 100%;" @click="gotoCategory(category.id)">
                  GO TO SPACE
                </div>
              </v-expand-transition>
            </v-card>
          </v-hover>
        </v-flex>

        <v-flex xs6 sm2 v-if="isCommunityJoined">
          <v-card color="grey" class="black--text pa-1" height="90px">
            <v-layout align-center justify-center row fill-height>
              <v-flex xs12>
                <div class="mt-2 text-xs-center">
                  <v-btn round color="teal" dark
                         slot="activator" @click="openCategoryDialog()" small>Add Space</v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout row wrap v-if="latestTopics.length" style="min-width: 100%">
        <v-container fluid grid-list-lg>
          <h2 fluid class="text-xs-center">Latest Topics</h2>
        </v-container>
        <template v-for="(topic, topicIndex) in latestTopics">
          <TopicCard :key="topicIndex" :topic="topic"></TopicCard>
        </template>
      </v-layout>
    </v-container>
  </v-layout>
</template>

<script>
import firebase from 'firebase';
import TiptapEditor from '@/components/TiptapEditor.vue';
import { Emoji, Picker } from 'emoji-mart-vue';
import TopicCard from '@/components/topic/TopicCard.vue';

export default {
  name: 'HomeSpace',
  components: {
    TopicCard,
    Emoji,
    TiptapEditor,
  },
  props: {
    user: Object,
    communityId: String,
    isCommunityJoined: Boolean,
    about: String,
    categories: Array,
  },
  data() {
    return {
      latestTopics: [],
    };
  },
  computed: {
    communityName() {
      return this.$store.state.communityName;
    },
  },
  created() {
    this.getLatestTopics();
  },
  watch: {
    communityId(newValue, oldValue) {
      this.getLatestTopics();
    },
  },
  methods: {
    gotoCategory(categoryId) {
      this.$router.push(`/c/${this.communityId}/category/${categoryId}`);
    },
    gotoTopic(topicId) {
      this.$router.push(`/c/${this.communityId}/topic/${topicId}`);
    },
    openCategoryDialog() {
      this.$emit('openCategoryDialog');
    },
    getLatestTopics() {
      this.latestTopics = [];

      const latestTopicsRef = firebase.firestore().collection(`communities/${this.communityId}/topics`).orderBy('createdAt', 'desc');

      latestTopicsRef.get().then((querySnapshot) => {
        if (!querySnapshot.empty) {
          querySnapshot.forEach((topicDoc) => {
            this.addTopicDoc(topicDoc);
          });
        }
      }).catch((error) => {
        console.error(error);
      });
    },
    addTopicDoc(topicDoc) {
      const topic = {
        id: topicDoc.id,
        communityId: this.communityId,
        title: topicDoc.data().title,
        about: topicDoc.data().about,
        color: topicDoc.data().color,
        isPublic: topicDoc.data().isPublic,
        isPinned: topicDoc.data().isPinned,
        userRef: topicDoc.data().userRef,
        categoryRef: topicDoc.data().categoryRef,
        likes: topicDoc.data().likes,
        isLiked: topicDoc.data().likes
          ? topicDoc.data().likes.filter(like => this.user && (like.uid === this.user.uid)).length : false,
        shares: topicDoc.data().shares,
        commentNum: topicDoc.data().commentNum,
        createdAt: topicDoc.data().createdAt,
      };

      if (topic.isPinned) {
        this.latestTopics.unshift(topic);
      } else {
        this.latestTopics.push(topic);
      }
    },
  },
};
</script>

<style scoped>
  .v-card--reveal {
    align-items: center;
    bottom: 0;
    justify-content: center;
    opacity: .75;
    position: absolute;
    width: 100%;
    z-index: 100;
  }
</style>
